module.exports = __webpack_public_path__ + "img/男士.88c53b0e.png";